import { SELF_SIGNUP_ENABLED } from '@/config/constants';

enum Access {
  ONLY_SIGNED_OUT = 'ONLY_SIGNED_OUT', // can be accessed by signed out users only
  ONLY_SIGNED_IN = 'ONLY_SIGNED_IN', // can be accessed by signed in users only
  PUBLIC = 'PUBLIC', // can be accessed by anyone
}

const staffPaths = {
  staff: [Access.ONLY_SIGNED_IN, '/staff'],

  organizations: [Access.ONLY_SIGNED_IN, '/staff/organizations'],
  organization: [Access.ONLY_SIGNED_IN, '/staff/organizations/:organizationId'],
  organizationNdiSubscriptions: [Access.ONLY_SIGNED_IN, '/staff/organizations/:organizationId/ndi'],
  organizationNdiSubscriptionEdit: [
    Access.ONLY_SIGNED_IN,
    '/staff/organizations/:organizationId/ndi/:jobSubscriptionId/edit',
  ],
  organizationNdiPlotPortfolioSubscriptionEdit: [
    Access.ONLY_SIGNED_IN,
    '/staff/organizations/:organizationId/ndi/plot-portfolio/:plotPortfolioSubscriptionId/edit',
  ],
  organizationNdiFinancial: [Access.ONLY_SIGNED_IN, '/staff/organizations/:organizationId/ndi/financial'],

  signUp: [Access.ONLY_SIGNED_OUT, SELF_SIGNUP_ENABLED ? '/staff/sign-up' : '/staff/sign-up-0e4edc79'],
  completeAccount: [Access.ONLY_SIGNED_IN, '/staff/complete-account'],

  account: [Access.ONLY_SIGNED_IN, '/staff/account'],
  accountEditEmail: [Access.ONLY_SIGNED_IN, '/staff/account/edit-email'],
  accountEditName: [Access.ONLY_SIGNED_IN, '/staff/account/edit-name'],
  accountEditPassword: [Access.ONLY_SIGNED_IN, '/staff/account/edit-password'],
  accountLegal: [Access.ONLY_SIGNED_IN, '/staff/account/legal'],
  accountTeam: [Access.ONLY_SIGNED_IN, '/staff/account/team'],
  accountTeamEditMember: [Access.ONLY_SIGNED_IN, '/staff/account/team/edit/:memberId'],
  accountTeamInvite: [Access.ONLY_SIGNED_IN, '/staff/account/team/invite'],

  home: [Access.ONLY_SIGNED_IN, '/staff/home'],
  contracts: [Access.ONLY_SIGNED_IN, '/staff/contracts'],
  reports: [Access.ONLY_SIGNED_IN, '/staff/reports'],

  copilot: [Access.ONLY_SIGNED_IN, '/staff/copilot'],
  globalCopilot: [Access.ONLY_SIGNED_IN, '/staff/global/copilot'],
  knowledge: [Access.ONLY_SIGNED_IN, '/staff/knowledge'],

  projects: [Access.ONLY_SIGNED_IN, '/staff/projects'],
  projectsComplianceFrameworks: [Access.ONLY_SIGNED_IN, '/staff/projects/compliance-frameworks'],
  newProject: [Access.ONLY_SIGNED_IN, '/staff/projects/new'],

  legacy_projectDetails: [Access.ONLY_SIGNED_IN, '/staff/projects/legacy/:projectId'],
  details: [Access.ONLY_SIGNED_IN, '/staff/details'],
  projectDetails: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId'],

  nca: [Access.ONLY_SIGNED_IN, '/staff/details/nca'],
  ncaProjects: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/nca'],
  landMonitoring: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/land-monitoring'],
  projectDetailsWater: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/water'],
  biodiversityDetails: [Access.ONLY_SIGNED_IN, '/staff/details/biodiversity'],
  soilDetails: [Access.ONLY_SIGNED_IN, '/staff/details/soil'],
  carbonDetails: [Access.ONLY_SIGNED_IN, '/staff/details/carbon'],
  socialDetails: [Access.ONLY_SIGNED_IN, '/staff/details/social'],
  waterDetails: [Access.ONLY_SIGNED_IN, '/staff/details/water'],
  impactProjections: [Access.ONLY_SIGNED_IN, '/staff/details/impact-projections'],
  impactProjectionsV2: [Access.ONLY_SIGNED_IN, '/staff/details/impact-projections-v2'],

  interactiveMap: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/interactive-map'],
  plotInteractiveMap: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId/interactive-map'],
  ecologicalIntegrity: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/ecological-integrity'],
  habitatIntactness: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/habitat-intactness'],
  indicatorSpecies: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/indicator-species'],
  ndvi: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/ndvi'],

  legacy_plots: [Access.ONLY_SIGNED_IN, '/staff/projects/legacy/:projectId/plots'],
  legacy_plot: [Access.ONLY_SIGNED_IN, '/staff/projects/legacy/:projectId/plots/:plotId'],

  plots: [Access.ONLY_SIGNED_IN, '/staff/plots'],
  groups: [Access.ONLY_SIGNED_IN, '/staff/groups'],
  comparisons: [Access.ONLY_SIGNED_IN, '/staff/comparisons'],
  compare: [Access.ONLY_SIGNED_IN, '/staff/compare'],

  plotGroupPlots: [Access.ONLY_SIGNED_IN, '/staff/details/plots'],
  plot: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId'],
  plotOverview: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId/overview'],
  plotLandMonitoring: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId/land-monitoring'],

  newPlot: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/new'],
  newPlotDrawBoundary: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/new/draw-boundary'],
  newPlotUpload: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/new/upload'],
  newPlotReviewUpload: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/new/review'],
  newPlotQuestionnaire: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/new/questionnaire'],
  newPlotSuccess: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/new/success'],
  editPlot: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/:plotId/edit'],
  editPlotBoundary: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/:plotId/edit/boundary'],
  editPlotSuccess: [Access.ONLY_SIGNED_IN, '/staff/projects/:projectId/plot/:plotId/edit/success'],
  editPlotOrg: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId/edit'],
  editPlotOrgBoundary: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId/edit/boundary'],
  editPlotOrgSuccess: [Access.ONLY_SIGNED_IN, '/staff/plots/:plotId/edit/success'],

  investments: [Access.ONLY_SIGNED_IN, '/staff/investments'],

  portfolio: [Access.ONLY_SIGNED_IN, '/staff/portfolio'],
  portfolioNaturalCapital: [Access.ONLY_SIGNED_IN, '/staff/portfolio/natural-capital'],
  portfolioForecasts: [Access.ONLY_SIGNED_IN, '/staff/portfolio/forecasts'],
  portfolioInvestments: [Access.ONLY_SIGNED_IN, '/staff/portfolio/investments'],
  portfolioUnits: [Access.ONLY_SIGNED_IN, '/staff/portfolio/units'],
  portfolioStocks: [Access.ONLY_SIGNED_IN, '/staff/portfolio/stocks'],
  portfolioContracts: [Access.ONLY_SIGNED_IN, '/staff/portfolio/contracts'],

  scenarioModels: [Access.ONLY_SIGNED_IN, '/staff/scenario-models'],
  scenarioModelsPhysicalRisk: [Access.ONLY_SIGNED_IN, '/staff/scenario-models/physical-risk'],
  scenarioModelsFinancialImpact: [Access.ONLY_SIGNED_IN, '/staff/scenario-models/financial-impact'],
  scenarioModelsMethodology: [Access.ONLY_SIGNED_IN, '/staff/scenario-models/methodology'],

  disclosure: [Access.ONLY_SIGNED_IN, '/staff/disclosure'],
  disclosureDependencies: [Access.ONLY_SIGNED_IN, '/staff/disclosure/dependencies'],
  disclosureImpacts: [Access.ONLY_SIGNED_IN, '/staff/disclosure/impacts'],

  indicators: [Access.ONLY_SIGNED_IN, '/staff/indicators'],

  organizationOnboarding: [Access.ONLY_SIGNED_IN, '/staff/organization/:organizationId/onboarding/:onboardingSection'],

  uploads: [Access.ONLY_SIGNED_IN, '/staff/uploads'],
  uploadsPlotOverview: [Access.ONLY_SIGNED_IN, '/staff/uploads/plot-overview'],
  uploadsPlotOverviewPlot: [Access.ONLY_SIGNED_IN, '/staff/uploads/plot-overview/:plotId'],
  insituDataUpload: [Access.ONLY_SIGNED_IN, '/staff/uploads/in-situ-data'],
  mediaMaps: [Access.ONLY_SIGNED_IN, '/staff/uploads/media-maps'],
  mediaMapsConfiguration: [Access.ONLY_SIGNED_IN, '/staff/uploads/media-maps/:configurationId'],

  plotUpload: [Access.ONLY_SIGNED_IN, '/staff/plot-upload'],
  plotCoordinateUpload: [Access.ONLY_SIGNED_IN, '/staff/plot-coordinate-upload'],

  restrictedAccess: [Access.ONLY_SIGNED_IN, '/staff/restricted-access'],

  workstreams: [Access.ONLY_SIGNED_IN, '/staff/workstreams'],
  workstreamsAdd: [Access.ONLY_SIGNED_IN, '/staff/workstreams/add'],
  workstreamsEdit: [Access.ONLY_SIGNED_IN, '/staff/workstreams/edit/workstream/:workstreamId'],

  ndiProducts: [Access.ONLY_SIGNED_IN, '/staff/ndi/products'],
} as const;

const landStewardPaths = {
  signUp: [Access.ONLY_SIGNED_OUT, SELF_SIGNUP_ENABLED ? '/landsteward/sign-up' : '/landsteward/sign-up-0e4edc79'],
  completeAccount: [Access.ONLY_SIGNED_IN, '/landsteward/complete-account'],

  account: [Access.ONLY_SIGNED_IN, '/landsteward/account'],
  accountEditEmail: [Access.ONLY_SIGNED_IN, '/landsteward/account/edit-email'],
  accountEditName: [Access.ONLY_SIGNED_IN, '/landsteward/account/edit-name'],
  accountEditPassword: [Access.ONLY_SIGNED_IN, '/landsteward/account/edit-password'],
  accountLegal: [Access.ONLY_SIGNED_IN, '/landsteward/account/legal'],
  accountTeam: [Access.ONLY_SIGNED_IN, '/landsteward/account/team'],
  accountTeamEditMember: [Access.ONLY_SIGNED_IN, '/landsteward/account/team/edit/:memberId'],
  accountTeamInvite: [Access.ONLY_SIGNED_IN, '/landsteward/account/team/invite'],

  home: [Access.ONLY_SIGNED_IN, '/landsteward/home'],
  contracts: [Access.ONLY_SIGNED_IN, '/landsteward/contracts'],
  reports: [Access.ONLY_SIGNED_IN, '/landsteward/reports'],

  copilot: [Access.ONLY_SIGNED_IN, '/landsteward/copilot'],
  knowledge: [Access.ONLY_SIGNED_IN, '/landsteward/knowledge'],

  projects: [Access.ONLY_SIGNED_IN, '/landsteward/projects'],
  projectsComplianceFrameworks: [Access.ONLY_SIGNED_IN, '/landsteward/projects/compliance-frameworks'],
  newProject: [Access.ONLY_SIGNED_IN, '/landsteward/projects/new'],

  legacy_projectDetails: [Access.ONLY_SIGNED_IN, '/landsteward/projects/legacy/:projectId'],
  details: [Access.ONLY_SIGNED_IN, '/landsteward/details'],
  projectDetails: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId'],

  nca: [Access.ONLY_SIGNED_IN, '/landsteward/details/nca'],
  ncaProjects: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/nca'],
  landMonitoring: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/land-monitoring'],
  projectDetailsWater: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/water'],
  biodiversityDetails: [Access.ONLY_SIGNED_IN, '/landsteward/details/biodiversity'],
  soilDetails: [Access.ONLY_SIGNED_IN, '/landsteward/details/soil'],
  carbonDetails: [Access.ONLY_SIGNED_IN, '/landsteward/details/carbon'],
  socialDetails: [Access.ONLY_SIGNED_IN, '/landsteward/details/social'],
  waterDetails: [Access.ONLY_SIGNED_IN, '/landsteward/details/water'],
  impactProjections: [Access.ONLY_SIGNED_IN, '/landsteward/details/impact-projections'],
  impactProjectionsV2: [Access.ONLY_SIGNED_IN, '/landsteward/details/impact-projections-v2'],

  interactiveMap: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/interactive-map'],
  plotInteractiveMap: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId/interactive-map'],
  ecologicalIntegrity: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/ecological-integrity'],
  habitatIntactness: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/habitat-intactness'],
  indicatorSpecies: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/indicator-species'],
  ndvi: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/ndvi'],

  legacy_plots: [Access.ONLY_SIGNED_IN, '/landsteward/projects/legacy/:projectId/plots'],
  legacy_plot: [Access.ONLY_SIGNED_IN, '/landsteward/projects/legacy/:projectId/plots/:plotId'],

  plots: [Access.ONLY_SIGNED_IN, '/landsteward/plots'],
  groups: [Access.ONLY_SIGNED_IN, '/landsteward/groups'],
  comparisons: [Access.ONLY_SIGNED_IN, '/landsteward/comparisons'],
  compare: [Access.ONLY_SIGNED_IN, '/landsteward/compare'],

  plotGroupPlots: [Access.ONLY_SIGNED_IN, '/landsteward/details/plots'],
  plot: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId'],
  plotOverview: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId/overview'],
  plotLandMonitoring: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId/land-monitoring'],

  newPlot: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/new'],
  newPlotDrawBoundary: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/new/draw-boundary'],
  newPlotUpload: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/new/upload'],
  newPlotReviewUpload: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/new/review'],
  newPlotQuestionnaire: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/new/questionnaire'],
  newPlotSuccess: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/new/success'],
  editPlot: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/:plotId/edit'],
  editPlotBoundary: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/:plotId/edit/boundary'],
  editPlotSuccess: [Access.ONLY_SIGNED_IN, '/landsteward/projects/:projectId/plot/:plotId/edit/success'],
  editPlotOrg: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId/edit'],
  editPlotOrgBoundary: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId/edit/boundary'],
  editPlotOrgSuccess: [Access.ONLY_SIGNED_IN, '/landsteward/plots/:plotId/edit/success'],

  investments: [Access.ONLY_SIGNED_IN, '/landsteward/investments'],

  portfolio: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio'],
  portfolioNaturalCapital: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio/natural-capital'],
  portfolioForecasts: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio/forecasts'],
  portfolioInvestments: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio/investments'],
  portfolioUnits: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio/units'],
  portfolioStocks: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio/stocks'],
  portfolioContracts: [Access.ONLY_SIGNED_IN, '/landsteward/portfolio/contracts'],

  scenarioModels: [Access.ONLY_SIGNED_IN, '/landsteward/scenario-models'],
  scenarioModelsPhysicalRisk: [Access.ONLY_SIGNED_IN, '/landsteward/scenario-models/physical-risk'],
  scenarioModelsFinancialImpact: [Access.ONLY_SIGNED_IN, '/landsteward/scenario-models/financial-impact'],
  scenarioModelsMethodology: [Access.ONLY_SIGNED_IN, '/landsteward/scenario-models/methodology'],

  disclosure: [Access.ONLY_SIGNED_IN, '/landsteward/disclosure'],
  disclosureDependencies: [Access.ONLY_SIGNED_IN, '/landsteward/disclosure/dependencies'],
  disclosureImpacts: [Access.ONLY_SIGNED_IN, '/landsteward/disclosure/impacts'],

  indicators: [Access.ONLY_SIGNED_IN, '/landsteward/indicators'],

  restrictedAccess: [Access.ONLY_SIGNED_IN, '/landsteward/restricted-access'],

  organizationOnboarding: [
    Access.ONLY_SIGNED_IN,
    '/landsteward/organization/:organizationId/onboarding/:onboardingSection',
  ],

  uploads: [Access.ONLY_SIGNED_IN, '/landsteward/uploads'],
  uploadsPlotOverview: [Access.ONLY_SIGNED_IN, '/landsteward/uploads/plot-overview'],
  uploadsPlotOverviewPlot: [Access.ONLY_SIGNED_IN, '/landsteward/uploads/plot-overview/:plotId'],
  insituDataUpload: [Access.ONLY_SIGNED_IN, '/landsteward/uploads/in-situ-data'],
  mediaMaps: [Access.ONLY_SIGNED_IN, '/landsteward/uploads/media-maps'],
  mediaMapsConfiguration: [Access.ONLY_SIGNED_IN, '/landsteward/uploads/media-maps/:configurationId'],

  // Draft-only spike (MVP-10324): gated by the plots_onboarding_client_draft feature flag,
  // see PlotsOnboardingProtection.
  plotUpload: [Access.ONLY_SIGNED_IN, '/landsteward/plot-upload'],
  plotCoordinateUpload: [Access.ONLY_SIGNED_IN, '/landsteward/plot-coordinate-upload'],

  workstreams: [Access.ONLY_SIGNED_IN, '/landsteward/workstreams'],
  workstreamsAdd: [Access.ONLY_SIGNED_IN, '/landsteward/workstreams/add'],
  workstreamsEdit: [Access.ONLY_SIGNED_IN, '/landsteward/workstreams/edit'],
} as const;

const buyerPaths = {
  completeAccount: [Access.ONLY_SIGNED_OUT, '/buyer/complete-account'],

  account: [Access.ONLY_SIGNED_IN, '/buyer/account'],
  accountEditEmail: [Access.ONLY_SIGNED_IN, '/buyer/account/edit-email'],
  accountEditName: [Access.ONLY_SIGNED_IN, '/buyer/account/edit-name'],
  accountEditPassword: [Access.ONLY_SIGNED_IN, '/buyer/account/edit-password'],
  accountLegal: [Access.ONLY_SIGNED_IN, '/buyer/account/legal'],
  accountTeam: [Access.ONLY_SIGNED_IN, '/buyer/account/team'],
  accountTeamEditMember: [Access.ONLY_SIGNED_IN, '/buyer/account/team/edit/:memberId'],
  accountTeamInvite: [Access.ONLY_SIGNED_IN, '/buyer/account/team/invite'],

  home: [Access.ONLY_SIGNED_IN, '/buyer/home'],
  contracts: [Access.ONLY_SIGNED_IN, '/buyer/contracts'],
  reports: [Access.ONLY_SIGNED_IN, '/buyer/reports'],

  copilot: [Access.ONLY_SIGNED_IN, '/buyer/copilot'],
  knowledge: [Access.ONLY_SIGNED_IN, '/buyer/knowledge'],

  projects: [Access.ONLY_SIGNED_IN, '/buyer/projects'],
  projectsComplianceFrameworks: [Access.ONLY_SIGNED_IN, '/buyer/projects/compliance-frameworks'],

  legacy_projectDetails: [Access.ONLY_SIGNED_IN, '/buyer/projects/legacy/:projectId'],
  details: [Access.ONLY_SIGNED_IN, '/buyer/details'],
  projectDetails: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId'],

  nca: [Access.ONLY_SIGNED_IN, '/buyer/details/nca'],
  ncaProjects: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/nca'],
  landMonitoring: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/land-monitoring'],
  biodiversityDetails: [Access.ONLY_SIGNED_IN, '/buyer/details/biodiversity'],
  soilDetails: [Access.ONLY_SIGNED_IN, '/buyer/details/soil'],
  carbonDetails: [Access.ONLY_SIGNED_IN, '/buyer/details/carbon'],
  socialDetails: [Access.ONLY_SIGNED_IN, '/buyer/details/social'],
  waterDetails: [Access.ONLY_SIGNED_IN, '/buyer/details/water'],
  projectDetailsWater: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/water'],
  impactProjections: [Access.ONLY_SIGNED_IN, '/buyer/details/impact-projections'],
  impactProjectionsV2: [Access.ONLY_SIGNED_IN, '/buyer/details/impact-projections-v2'],

  interactiveMap: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/interactive-map'],
  plotInteractiveMap: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId/interactive-map'],
  ecologicalIntegrity: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/ecological-integrity'],
  habitatIntactness: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/habitat-intactness'],
  indicatorSpecies: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/indicator-species'],
  ndvi: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/ndvi'],

  legacy_plots: [Access.ONLY_SIGNED_IN, '/buyer/projects/legacy/:projectId/plots'],
  legacy_plot: [Access.ONLY_SIGNED_IN, '/buyer/projects/legacy/:projectId/plots/:plotId'],

  plots: [Access.ONLY_SIGNED_IN, '/buyer/plots'],
  groups: [Access.ONLY_SIGNED_IN, '/buyer/groups'],
  comparisons: [Access.ONLY_SIGNED_IN, '/buyer/comparisons'],
  compare: [Access.ONLY_SIGNED_IN, '/buyer/compare'],

  plotGroupPlots: [Access.ONLY_SIGNED_IN, '/buyer/details/plots'],
  plot: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId'],
  plotOverview: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId/overview'],
  plotLandMonitoring: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId/land-monitoring'],

  newPlotDrawBoundary: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/plot/new/draw-boundary'],
  newPlotUpload: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/plot/new/upload'],
  editPlot: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/plot/:plotId/edit'],
  editPlotBoundary: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/plot/:plotId/edit/boundary'],
  editPlotSuccess: [Access.ONLY_SIGNED_IN, '/buyer/projects/:projectId/plot/:plotId/edit/success'],
  editPlotOrg: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId/edit'],
  editPlotOrgBoundary: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId/edit/boundary'],
  editPlotOrgSuccess: [Access.ONLY_SIGNED_IN, '/buyer/plots/:plotId/edit/success'],

  investments: [Access.ONLY_SIGNED_IN, '/buyer/investments'],

  portfolio: [Access.ONLY_SIGNED_IN, '/buyer/portfolio'],
  portfolioNaturalCapital: [Access.ONLY_SIGNED_IN, '/buyer/portfolio/natural-capital'],
  portfolioForecasts: [Access.ONLY_SIGNED_IN, '/buyer/portfolio/forecasts'],
  portfolioInvestments: [Access.ONLY_SIGNED_IN, '/buyer/portfolio/investments'],
  portfolioUnits: [Access.ONLY_SIGNED_IN, '/buyer/portfolio/units'],
  portfolioStocks: [Access.ONLY_SIGNED_IN, '/buyer/portfolio/stocks'],
  portfolioContracts: [Access.ONLY_SIGNED_IN, '/buyer/portfolio/contracts'],

  scenarioModels: [Access.ONLY_SIGNED_IN, '/buyer/scenario-models'],
  scenarioModelsPhysicalRisk: [Access.ONLY_SIGNED_IN, '/buyer/scenario-models/physical-risk'],
  scenarioModelsFinancialImpact: [Access.ONLY_SIGNED_IN, '/buyer/scenario-models/financial-impact'],
  scenarioModelsMethodology: [Access.ONLY_SIGNED_IN, '/buyer/scenario-models/methodology'],

  disclosure: [Access.ONLY_SIGNED_IN, '/buyer/disclosure'],
  disclosureDependencies: [Access.ONLY_SIGNED_IN, '/buyer/disclosure/dependencies'],
  disclosureImpacts: [Access.ONLY_SIGNED_IN, '/buyer/disclosure/impacts'],

  indicators: [Access.ONLY_SIGNED_IN, '/buyer/indicators'],

  organizationOnboarding: [Access.ONLY_SIGNED_IN, '/buyer/organization/:organizationId/onboarding/:onboardingSection'],

  uploads: [Access.ONLY_SIGNED_IN, '/buyer/uploads'],
  uploadsPlotOverview: [Access.ONLY_SIGNED_IN, '/buyer/uploads/plot-overview'],
  uploadsPlotOverviewPlot: [Access.ONLY_SIGNED_IN, '/buyer/uploads/plot-overview/:plotId'],
  insituDataUpload: [Access.ONLY_SIGNED_IN, '/buyer/uploads/in-situ-data'],
  mediaMaps: [Access.ONLY_SIGNED_IN, '/buyer/uploads/media-maps'],
  mediaMapsConfiguration: [Access.ONLY_SIGNED_IN, '/buyer/uploads/media-maps/:configurationId'],

  restrictedAccess: [Access.ONLY_SIGNED_IN, '/buyer/restricted-access'],

  workstreams: [Access.ONLY_SIGNED_IN, '/buyer/workstreams'],
} as const;

const publicPaths = {
  activateAccount: [Access.PUBLIC, '/activate-account'],

  confirmMailChange: [Access.ONLY_SIGNED_IN, '/confirm-mail-change'],

  login: [Access.ONLY_SIGNED_OUT, '/login'],
  loginImpersonate: [Access.PUBLIC, '/login/impersonate'],

  newPassword: [Access.ONLY_SIGNED_OUT, '/reset-password/new-password'],
  resetPassword: [Access.ONLY_SIGNED_OUT, '/reset-password'],

  invalidUrl: [Access.PUBLIC, '/invalid-url'],

  root: [Access.PUBLIC, '/'],
} as const;

const extractKeyRoute = <T extends string>(routes: Record<T, readonly [Access, string]>): Record<T, string> => {
  return Object.entries<readonly [Access, string]>(routes).reduce(
    (acc, [key, value]) => {
      const route = value[1];
      acc[key as T] = route;
      return acc;
    },
    {} as Record<T, string>,
  );
};

type LandStewardKeys = keyof typeof landStewardPaths;
type BuyerKeys = keyof typeof buyerPaths;
type StaffKeys = keyof typeof staffPaths;
type PublicKeys = keyof typeof publicPaths;

type PathsType = Record<PublicKeys, string> & {
  landSteward: Record<LandStewardKeys, string>;
} & {
  buyer: Record<BuyerKeys, string>;
} & {
  staff: Record<StaffKeys, string>;
};

export const paths: PathsType = {
  ...extractKeyRoute<PublicKeys>(publicPaths),
  landSteward: extractKeyRoute<LandStewardKeys>(landStewardPaths),
  buyer: extractKeyRoute<BuyerKeys>(buyerPaths),
  staff: extractKeyRoute<StaffKeys>(staffPaths),
};

const extractRoutesByAccess = (routes: Record<string, readonly [Access, string]>, access: Access) => {
  return [
    ...Object.values(routes)
      .filter((route) => route[0] === access)
      .map((route) => route[1]),
  ];
};

const getRoutesByAccess = (access: Access): string[] => {
  return [
    ...extractRoutesByAccess(publicPaths, access),
    ...extractRoutesByAccess(landStewardPaths, access),
    ...extractRoutesByAccess(buyerPaths, access),
    ...extractRoutesByAccess(staffPaths, access),
  ];
};

export const onlySignedOutRoutes = getRoutesByAccess(Access.ONLY_SIGNED_OUT);
export const onlySignedInRoutes = getRoutesByAccess(Access.ONLY_SIGNED_IN);
export const publicRoutes = getRoutesByAccess(Access.PUBLIC);
